import { IMPROVISES, improviseById } from '../data/improvise';
import { RNG } from '../core/rng';
import { recalcStats, registerModSource } from './stats';
/* ============================================================
   應急改裝的持有狀態（可選池見底之後的無限強化）
   ============================================================

   設計依據在 `data/improvise.ts`。這裡只管三件事：誰現在幾級、
   發哪三張、把修正丟進 `sim/stats.ts` 的修正層。

   形狀照 `sim/mech-upgrades.ts`（同樣是「不佔槽、不進一般抽卡池」的一層）：
   等級放模組變數而不是 `P` 上，重置責任集中在 `resetLoadout()` 一個地方 ——
   這個專案記過三次「新欄位忘了在 startRun 歸零」。 */

var levels: Record<string, number> = {};

export function resetImprovises() {
  levels = {};
  recalcStats();
}

export function improviseLevel(id: string) { return levels[id] || 0; }

/** 永遠拿得到（沒有上限，理由見 `data/improvise.ts`）。 */
export function canTakeImprovise(id: string) { return !!improviseById(id); }

export function takeImprovise(id: string) {
  var d = improviseById(id);
  if (!d) return 0;
  levels[id] = improviseLevel(id) + 1;
  recalcStats();
  /* `onTake` **在 recalcStats 之後**：結構上限那一項改的是 `P.hpMax`，
     而 `recalcStats()` 會依 `P.base` 重算 `P.s`，兩者互不影響 ——
     但順序寫反的話下一個讀 `P.s` 的人拿到的是舊值。 */
  if (d.onTake) d.onTake();
  return levels[id];
}

/** 這一次發哪三張。**從五項裡不放回抽三個**，用種子 RNG。

    為什麼不固定發同三張：固定的話這一層就退化成「每次都選同一個最優解」，
    等於沒有決策。抽三張讓「這次有沒有出現我要的那條」變成真的取捨 ——
    跟一般三選一同一個語彙。

    為什麼不照權重：五項都是純數值、彼此對稱，沒有稀有度可言。
    加權只會讓某一項變成事實上的必選項。 */
export function improviseIds() {
  var pool: string[] = [];
  for (var i = 0; i < IMPROVISES.length; i++) {
    if (canTakeImprovise(IMPROVISES[i].id)) pool.push(IMPROVISES[i].id);
  }
  var out: string[] = [];
  var n = pool.length < 3 ? pool.length : 3;
  for (var k = 0; k < n; k++) {
    var j = pool.length === 1 ? 0 : Math.floor(RNG.next() * pool.length) % pool.length;
    out.push(pool[j]);
    pool.splice(j, 1);
  }
  return out;
}

/** 給快照用。併進 `loadoutDigest()` —— 不併的話「同種子兩場的應急改裝不同」
    對決定性測試是隱形的。 */
export function improviseDigest() {
  var s = '';
  for (var i = 0; i < IMPROVISES.length; i++) {
    var id = IMPROVISES[i].id;
    if (levels[id]) s += id + levels[id] + ',';
  }
  return s;
}

/** 這一場總共拿了幾級（給結算畫面與量測用）。 */
export function improviseTotal() {
  var n = 0;
  for (var i = 0; i < IMPROVISES.length; i++) n += levels[IMPROVISES[i].id] || 0;
  return n;
}

registerModSource(function () {
  var out: any[] = [];
  for (var i = 0; i < IMPROVISES.length; i++) {
    var u = IMPROVISES[i], lv = levels[u.id] || 0;
    if (lv > 0) out.push(u.mods(lv));
  }
  return out;
});
